// extracted by mini-css-extract-plugin
export default {"label":"AvailableOnPlansChip-module__label___ugzkL","link":"AvailableOnPlansChip-module__link___x8T1c","tooltipText":"AvailableOnPlansChip-module__tooltipText___qI3KD"};